<div class="app-property-list container-fluid">
  <!-- Property List -->
  <div class="col">
    <form [formGroup]="form">
      <div *ngFor="let control of form.controls; let i = index" class="row mb-4">
        <ng-container [formGroupName]="i">
          <!-- Property -->
          <div class="col-lg-3 col-md-6 col-sm-6">
            <mat-form-field>
              <mat-label>Property</mat-label>
              <mat-select formControlName="property" (selectionChange)="onChangeProperty($event, control)">
                <mat-option
                  *ngFor="
                    let property of form.value | applyFunctionOrValue: getPropertiesToDisplay:control.value.property
                  "
                  [value]="property"
                >
                  {{ property.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Operator -->
          <div class="col-lg-3 col-md-6 col-sm-6">
            <mat-form-field>
              <mat-label>Operator</mat-label>
              <mat-select
                formControlName="operator"
                (selectionChange)="onChangeOperator($event, control)"
                [disabled]="control.value?.property?.operators?.length <= 1"
              >
                <mat-option *ngFor="let operator of control.value?.property?.operators" [value]="operator">
                  {{ config.operators[operator].label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Value -->
          <div class="col-lg-3 col-md-6 col-sm-6" [ngSwitch]="control.value?.property?.control">
            <!-- Input -->
            <ng-container *ngSwitchCase="'input'" [ngTemplateOutlet]="input"> </ng-container>
            <!-- Search -->
            <ng-container *ngSwitchCase="'search'" [ngTemplateOutlet]="search"> </ng-container>
            <!-- Date -->
            <ng-container *ngSwitchCase="'date'" [ngTemplateOutlet]="date"> </ng-container>
            <!-- Select -->
            <ng-container *ngSwitchCase="'select'" [ngTemplateOutlet]="select"> </ng-container>
            <!-- Default -->
            <ng-container *ngSwitchDefault [ngTemplateOutlet]="input"> </ng-container>
          </div>
          <ng-template #input>
            <mat-form-field>
              <mat-label>Value</mat-label>
              <input matInput type="text" formControlName="value" /> </mat-form-field
          ></ng-template>
          <ng-template #search>
            <mat-form-field>
              <mat-label>Value</mat-label>
              <input matInput type="text" formControlName="value" [matAutocomplete]="auto" />
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="searchInputLabel">
                <mat-option *ngIf="control.value?.property?.search?.showNullOption" [value]="null">None</mat-option>
                <mat-option
                  (click)="$event.stopPropagation()"
                  *ngFor="let option of options[control.value?.property?.key] | async"
                  [value]="option"
                >
                  {{ option[control.value?.property?.search.propToDisplay] }}
                </mat-option>
              </mat-autocomplete>
              <mat-spinner
                *ngIf="control.value?.property?.search?.loading"
                matSuffix
                [diameter]="18"
                style="float: right; margin-left: 8px"
              ></mat-spinner>
            </mat-form-field>
          </ng-template>
          <ng-template #date>
            <mat-form-field>
              <mat-label>Value</mat-label>
              <input
                matInput
                type="text"
                formControlName="value"
                [matDatepicker]="datePicker"
                [min]="control.value?.property?.date?.min"
                [max]="control.value?.property?.date?.max"
                (click)="datePicker.open()"
              />
              <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
              <mat-datepicker color="primary" #datePicker></mat-datepicker> </mat-form-field
          ></ng-template>
          <ng-template #select>
            <mat-form-field>
              <mat-label>Value</mat-label>
              <mat-select formControlName="value">
                <mat-option *ngFor="let option of control.value?.property?.select?.options" [value]="option.value"
                  >{{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
          <!-- Remove / Add Buttons -->
          <div class="col-lg-3 col-md-6 col-sm-6">
            <button
              *ngIf="form.controls.length > 1"
              mat-mini-fab
              class="btn mat-warn control-button mr-2"
              (click)="onRemoveProperty(i)"
            >
              <mat-icon>remove</mat-icon>
            </button>
            <button
              *ngIf="form.controls.length - 1 === i && form.value.length < config.properties.length"
              mat-mini-fab
              class="btn btn-primary control-button"
              (click)="onAddProperty()"
            >
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </ng-container>
      </div>
    </form>
    <!-- Summary -->
    <div *ngIf="config.summary" class="row wrapper-summary">
      <div class="col summary">Total {{ config.summary.entity }} to update: {{ config.summary.selectedItems }}</div>
    </div>
    <!-- Buttons -->
    <div *ngIf="!config.buttons?.hidden" class="row justify-content-center mt-4">
      <button class="mr-1" cdkFocusInitial mat-stroked-button color="warn" [mat-dialog-close]="false">
        {{ "Cancel" }}
      </button>
      <button class="ml-1" mat-raised-button color="accent" (click)="config.buttons?.submit?.action(this)">
        {{ config.buttons?.submit?.name || "Submit" }}
      </button>
    </div>
  </div>
</div>
